import { createFileRoute } from '@tanstack/react-router';
import { ReportListPage } from '@/components/finance';

export const Route = createFileRoute('/admin/finance/reports/')({
  component: ReportsPage,
});

function ReportsPage() {
  return (
    <div className="p-6">
      <ReportListPage />
    </div>
  );
}
